/* eslint-disable */
import { DownloadOutlined } from '@ant-design/icons';
import { Button, Modal, Space, Spin } from 'antd';
import tune from 'common/assets/icons/ic_tune.png';
import { downloadFile } from "common/utils/functions";
import React from 'react';
import { useTranslation } from 'react-i18next';

interface PopupGuideSettingPopupsProps {
  isPopupBlock: { status: boolean; link: string };
  onClose: () => void;
  isLoading: boolean;
  fileName?: string
}

const PopupGuideSettingPopups: React.FC<PopupGuideSettingPopupsProps> = ({
  isLoading,
  isPopupBlock,
  fileName,
  onClose
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={isPopupBlock.status}
      onCancel={onClose}
      footer={null}
      centered
      className="t-pagetable_popupBlockedModal"
      width={500}
      title="Trình duyệt đã chặn Pop-up khi mở file"
    >
      {
        isLoading ? (
          <Space>
            <Spin size="small" style={{ marginLeft: 8 }} />
            Loading...
          </Space>
        ) : isPopupBlock.link ? (
          <Space direction="vertical">
            <p>
              Vui lòng
              {' '}
              <Button type="link" onClick={() => fileName ? downloadFile(isPopupBlock.link, fileName) : window.open(isPopupBlock.link, '_blank')}>
                <Space>
                  nhấn vào đây để tải file
                  <DownloadOutlined />
                </Space>
              </Button>
            </p>
            hoặc cho phép trình duyệt bật popup để tải file theo hướng dẫn sau:
          </Space>
        ) : (
          <p>{t('message.linkNotAvailable')}</p>
        )
      }

      <h4>Chrome</h4>
      <ul>
        <li>
          <span>
            Mở
          </span>
          {' '}
          <code>chrome://settings/content/popups</code>
          .
          {' '}
          Tìm website của bạn và cho phép Pop-ups and redirects là "Allow".
        </li>
        <li style={{ marginTop: '12px' }}>Hoặc bấm vào <img src={tune} width={24} height={24} style={{ marginBottom: '-8px' }} /> hoặc 🔒 trong thanh địa chỉ → Bật quyền Pop-ups and redirects.</li>
      </ul>

      <h4>Safari</h4>
      <ul>
        <li>{'Mở Safari > Settings > Websites > Pop-up Windows.'}</li>
        <li>Tìm website của bạn và chọn "Allow".</li>
      </ul>

      <p><strong>Sau khi bật, vui lòng tải lại trang và thử tải lại.</strong></p>
    </Modal>
  );
};

export default PopupGuideSettingPopups;
